import React, { Component } from 'react';

import getSelectField from '../../fields/select';
import getCheckboxField from '../../fields/checkbox';
import getFonts from '../../../Functions/config/fonts';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

class Heading extends Component {

    constructor(props) {
        super(props);
    }

    setColorsAndPreview = async (type, color) => {
        const { setColorsAndPreview } = this.props;
        await setColorsAndPreview('heading', type, color);
    }
    
    setHeadingColor = async (color) => {
        await this.setColorsAndPreview('headingColor', color);
    }

    setHeadingLabel = async (color) => {
        await this.setColorsAndPreview('headingLabel', color);
    }

    render(){

        const { widget, handleInputChange, toggleColorPicker } = this.props;
        const { prorated } = widget.htmlData;
        const fontOptions = getFonts();

        return(

            <div className="mjwi-acc-panel-wrapper">

                <label htmlFor="proratedHeading">Heading:</label>
                <input
                    type="text"
                    name="proratedHeading"
                    value={prorated.heading.proratedHeading}
                    onChange={handleInputChange}
                />
                
                <div className='mjwi-row'>    
                    <div className='mjwi-col33'>
                            <label>
                                Font Family
                            </label>                                    
                        </div>
                        <div className='mjwi-col66'>
                            {getSelectField('headingFontFamily', fontOptions, prorated.heading.headingFontFamily, handleInputChange)}
                        </div>
                </div>

                <div className='mjwi-row'>    
                    <div className='mjwi-col33 mjwi-row'>
                        <label htmlFor="headingFontSize">Size</label>&nbsp;
                        <input
                            type="number"
                            name="headingFontSize"
                            value={prorated.heading.headingFontSize}
                            onChange={handleInputChange}
                        />&nbsp;px
                    </div>
                    <div className='mjwi-col25'>
                        <label>
                            {getCheckboxField('headingFontBold', prorated.heading.headingFontBold, handleInputChange)}
                            Bold
                        </label>                                  
                    </div>
                    <div className='mjwi-col25'>
                        <label>
                            {getCheckboxField('headingFontItalic', prorated.heading.headingFontItalic, handleInputChange)}
                            Italic
                        </label>                                  
                    </div>                          
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Color</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.heading.headingColor }}></span>
                        <HexAlphaColorPicker color={prorated.heading.headingColor} onChange={this.setHeadingColor} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.heading.headingColor} onChange={this.setHeadingColor} />
                    </div>
                </div>

            </div>
        );
    }
}

export default Heading;
